<template>
    <section>
        <broadcast-item
                v-for="(item) in items"
                :key="item._id"
                :item="item"
                :labels="labelsMap"
                :countries="countries"
                @delete="deleteItem($event)"
                @openPairingDetails="openPairingDetails"
        />
        <div class="action_line" v-if="numberOfBroadcasts > params.limit">
            <app-table-pagination
                    :page="listPage"
                    :itemsPerPage="params.limit"
                    :totalCount="numberOfBroadcasts"
                    @pageChanged="tablePageChanged"
            />
        </div>
    </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from '../../../mixins/appTitleMixin'
import BroadcastItem from './BroadcastItem'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Broadcasts',
  preventFetchOnCreated: true
})

export default {
  name: 'show-broadcasts',
  mixins: [itemsListMixin, appTitleMixin()],
  components: {
    BroadcastItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      required: true
    }
  },
  created() {
    this.params.showId = this.item._id
    this.getLabelsForCurrentLanguage()
    this.fetchBroadcasts()
    this.tablePageChanged(1, false)
  },
  data() {
    return {
      currentTimestamp: null
    }
  },
  computed: {
    ...mapState({
      labels: state => state.labels.labels,
      labelsPending: state => state.labels.pending.labels,
      broadcastOverview: state => state.broadcasts.broadcastOverview,
      currentLanguageId: state => state.uiLanguages.currentLanguageId
    }),
    numberOfBroadcasts() {
      return this.itemsMetadata.totalCount
    },
    labelsMap() {
      return this.labels.reduce((obj, v) => {
        obj[v._id] = v.labelName
        return obj
      }, {})
    }
  },
  methods: {
    ...mapActions(['getLabels', 'getBroadcasts']),
    shouldConfirmDelete() {
      return false
    },
    getLabelsForCurrentLanguage() {
      this.getLabels({
        params: {
          idLanguage: this.currentLanguageId
        }
      })
    },
    fetchBroadcasts() {
      this.getBroadcasts({
        params: {
          showId: this.item._id,
          limit: this.params.limit,
          offset: this.params.offset
        }
      })
    },
    openPairingDetails(item) {
      this.$emit('openPairingDetails', item)
    },
    tablePageChanged(page, fetchItems = true) {
      this.listPage = page
      this.params.offset = (this.listPage - 1) * this.params.limit
      if (fetchItems) {
        this.fetchBroadcasts()
      }
    }
  },
  watch: {
    currentLanguageId() {
      this.getLabelsForCurrentLanguage()
    }
  }
}
</script>
